import { withTypography } from 'ucl/components/text/Typography';

export const PriceAndCaloriesText = withTypography({
  variant: 'copyTwo',
  textAlign: 'center',
  m: '$0',
  p: '$0',
});

export const Price = withTypography({ variant: 'copyTwo', bold: true });
